"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClientApplication = createClientApplication;
exports.getRedirectURIs = getRedirectURIs;
exports.updateClientApplication = updateClientApplication;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
function createClientApplication(_x) {
  return _createClientApplication.apply(this, arguments);
}
function _createClientApplication() {
  _createClientApplication = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(params) {
    var applicationService;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          applicationService = new _exchangeApiClient.ApplicationService(params.config);
          return _context.abrupt("return", applicationService.create(params));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createClientApplication.apply(this, arguments);
}
function updateClientApplication(_x2) {
  return _updateClientApplication.apply(this, arguments);
}
function _updateClientApplication() {
  _updateClientApplication = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(params) {
    var applicationService;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          applicationService = new _exchangeApiClient.ApplicationService(params.config);
          return _context2.abrupt("return", applicationService.update(params));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _updateClientApplication.apply(this, arguments);
}
function getRedirectURIs(anypointRedirectURIs, redirectURI, isAPIEndpointsSelected) {
  return (redirectURI ? redirectURI.split(',') : []).concat(isAPIEndpointsSelected ? anypointRedirectURIs : []);
}
//# sourceMappingURL=applications.js.map